import { ReadRecord } from './ReadRecord';
import { RecShapeIfc } from '../shape/RecShapeIfc';

export class WriteRecord extends ReadRecord{

    constructor(shape:RecShapeIfc, i:number)
    {
        super(shape, i);
    }
		
    public setIntAt(position:number, value:number):void
    {
        this.getRecShape().setIntAt(this.getId(), position, value);
    }
    
    public setNumberAt(position:number, value:number):void
    {
        this.getRecShape().setNumberAt(this.getId(), position, value);
    }
    
    public setBooleanAt(position:number, value:boolean):void
    {
        this.getRecShape().setBooleanAt(this.getId(), position, value);
    }
    
    public setStringAt(position:number, value:string):void
    {
        this.getRecShape().setStringAt(this.getId(), position, value);
    }
    
    public setIntByName(name:string, value:number):void
    {
        this.setIntAt(this.getRecShape().getColId(name), value);
    }
    
    public setNumberByName(name:string, value:number):void
    {
        this.setNumberAt(this.getRecShape().getColId(name), value);
    }
    
    public setBooleanByName(name:string, value:boolean):void
    {
        this.setBooleanAt(this.getRecShape().getColId(name), value);
    }
    
    public setStringByName(name:string, value:string):void
    {
        this.setStringAt(this.getRecShape().getColId(name), value);
    }
	
}